(function ($) {

    $(document).ready(function () {

        var $form = $("#add-multiple-variant-form");
        if (!$form.length) return;

        var moneyFormat = $form.attr("data-money-format") || "${{amount}}";
        var $addToCartBtn = $("#custom-add_toCart");
        var $wizardAddToCartBtn = $form.find("[data-wizard-add-to-cart]");
        var $dataWizardAddToCartBtn = $("[data-wizard-main-add-to-cart]");
        var $statusEl = $(".status");
        var $addonLinesEl = $(".addon-lines");
        var $reviewListEl = $form.find("[data-review-list]");

        // Quantity selector elements
        var $qtyInput = $("[data-qty-input]");
        var $qtyMinusBtn = $("[data-qty-minus]");
        var $qtyPlusBtn = $("[data-qty-plus]");

        // Set by initWizard(); used by refreshPricing() to keep the review
        // step in sync if the shopper edits a choice and returns to it.
        var wizardGoToStep = null;
        var isOnReviewStep = function () { return false; };

        // -----------------------------------------------------------------
        // PER-ROW QUANTITY STATE (added)
        // Main item quantity still lives on $qtyInput (unchanged behavior).
        // Each selected add-on now gets its own independent quantity so the
        // review step can show a stepper + Remove link per line, matching
        // the design (e.g. 1x jersey, 2x inscription).
        // -----------------------------------------------------------------
        var addonQuantities = {}; // { [addonVariantId]: qty }
        var ADDON_QTY_MAX_ATTR = "data-max-qty"; // optional per-addon cap in markup

        function getAddonMaxQty($addon) {
            var max = parseInt($addon.attr(ADDON_QTY_MAX_ATTR), 10);
            return isNaN(max) || max < 1 ? null : max;
        }

        function getAddonQty(addonId) {
            var qty = addonQuantities[addonId];
            return typeof qty === "number" && qty > 0 ? qty : 1;
        }

        function setAddonQty(addonId, qty, $addon) {
            var max = $addon ? getAddonMaxQty($addon) : null;
            if (qty < 1) qty = 1;
            if (max && qty > max) qty = max;
            addonQuantities[addonId] = qty;
        }

        // -----------------------------------------------------------------
        // Money formatting — data-multiple-price is in cents.
        // -----------------------------------------------------------------
        function formatMoney(cents) {
            if (cents === undefined || cents === null || cents === "" || isNaN(cents)) {
                return "";
            }
            var value = (Number(cents) / 100).toFixed(2);
            var parts = value.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            value = parts.join(".");

            if (moneyFormat.indexOf("{{amount}}") > -1) {
                return moneyFormat.replace("{{amount}}", value);
            }
            if (moneyFormat.indexOf("{{amount_no_decimals}}") > -1) {
                return moneyFormat.replace("{{amount_no_decimals}}", parts[0]);
            }
            return "$" + value;
        }

        var statusClearTimer = null;
        function setStatus(message, isError, autoClearMs, restoreText, restoreIsError) {
            if (statusClearTimer) {
                clearTimeout(statusClearTimer);
                statusClearTimer = null;
            }

            var textToRestore = (restoreText !== undefined) ? restoreText : $statusEl.text();
            var isErrorToRestore = (restoreIsError !== undefined) ? restoreIsError : $statusEl.hasClass("is-error");

            $statusEl.text(message || "").toggleClass("is-error", !!isError);

            if (autoClearMs) {
                statusClearTimer = setTimeout(function () {
                    $statusEl.text(textToRestore).toggleClass("is-error", isErrorToRestore);
                    statusClearTimer = null;
                }, autoClearMs);
            }
        }

        /* =================================================================
           QUANTITY SELECTOR (main item — summary card)
           ================================================================= */
        function getQuantity() {
            var val = parseInt($qtyInput.val(), 10);
            if (isNaN(val) || val < 1) val = 1;
            return val;
        }

        function setQuantity(val) {
            if (val < 1) val = 1;
            $qtyInput.val(val);
        }

        function clampQtyInput() {
            $qtyInput.val(getQuantity());
        }

        $qtyMinusBtn.on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            setQuantity(getQuantity() - 1);
            refreshPricing();
        });

        $qtyPlusBtn.on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            setQuantity(getQuantity() + 1);
            refreshPricing();
        });

        $qtyInput.on("change", function (event) {
            event.stopPropagation();
            clampQtyInput();
            refreshPricing();
        });

        $(".custom-add_toCart_qty_wrap").on("click", function (event) {
            event.stopPropagation();
        });

        /* =================================================================
           WIZARD STEP CONTROLLER
           ================================================================= */
        function initWizard() {
            var $steps = $form.find(".steps");
            var $progress = $form.find("[data-progress]");
            var $stepCountEl = $form.find("[data-step-count]");
            var $stepTitleEl = $form.find("[data-step-title]").first();
            var $backBtn = $form.find("[data-back-btn]");
            var $startHereNew = $form.find("[data-start-here-btn]");
            var $continueBtn = $("[data-continue-btn]");

            var $wizardActions = $form.find("[data-wizard-actions]");

            if ($steps.length <= 1) {
                $progress.hide();
                $wizardActions.hide();
                $form.find("[data-step-count]").hide();
                if ($steps.length === 1) $steps.eq(0).addClass("step-active");
                return;
            }

            $progress.empty();
            $steps.each(function () {
                $progress.append('<div class="progress-seg"><div class="progress-seg-fill"></div></div>');
            });

            var currentIndex = $steps.index($steps.filter(".step-active"));
            if (currentIndex < 0) currentIndex = 0;

            function renderStep(index) {
                $steps.removeClass("step-active");
                var $active = $steps.eq(index).addClass("step-active");

                $stepCountEl.text("STEP " + (index + 1) + " OF " + $steps.length);

                var title = $active.attr("data-step-title");
                if (title) $stepTitleEl.text(title);

                $progress.find(".progress-seg").each(function (i) {
                    var pct = i <= index ? "100%" : "0%";
                    $(this).find(".progress-seg-fill").css("width", pct);
                });

                var isLastStep = index === $steps.length - 1;
                var isFirstStep = index === 0;
                $backBtn.toggle(!isFirstStep);
                $startHereNew.toggle(isFirstStep);
                $continueBtn.toggle(!isLastStep);
                $wizardAddToCartBtn.toggle(isLastStep);

                if (isLastStep) {
                    renderReview();
                    $($dataWizardAddToCartBtn).css('display', 'block');
                    $('[data-continue-hide-main]').css('display', 'none');
                    $($dataWizardAddToCartBtn).removeAttr('disabled');
                } else {
                    $('[data-continue-hide-main]').css('display', 'block');
                    $($dataWizardAddToCartBtn).css('display', 'none');
                    $($dataWizardAddToCartBtn).attr('disabled', true);
                }
            }

            $backBtn.on("click", function () {
                if (currentIndex > 0) {
                    currentIndex -= 1;
                    renderStep(currentIndex);
                }
            });

            $continueBtn.on("click", function () {
                if (currentIndex < $steps.length - 1) {
                    currentIndex += 1;
                    renderStep(currentIndex);
                }
            });

            $form.on("click", "[data-edit-choices]", function (event) {
                event.preventDefault();
                currentIndex = 0;
                renderStep(currentIndex);
            });

            renderStep(currentIndex);

            wizardGoToStep = function (index) {
                currentIndex = index;
                renderStep(currentIndex);
            };
            isOnReviewStep = function () {
                return currentIndex === $steps.length - 1;
            };
        }

        /* =================================================================
           REVIEW STEP (per-row Remove + qty stepper — added)
           ================================================================= */
        function reviewRowHtml(opts) {
            // opts: { rowType: 'main'|'addon', rowId, title, unitPriceCents, qty, showQtyControls }
            //var totalCents = opts.unitPriceCents * opts.qty;
            var totalCents = opts.unitPriceCents;
            var unitNote = opts.rowType === "addon"
                ? formatMoney(opts.unitPriceCents) + " each"
                : formatMoney(opts.unitPriceCents);

            var qtyControls = opts.showQtyControls
                ? (
                    '<div class="review-row-qty">' +
                        '<button type="button" class="qty-btn" data-review-qty-minus data-row-type="' + opts.rowType + '" data-row-id="' + opts.rowId + '">\u2212</button>' +
                        '<input type="text" class="qty-input" readonly value="' + opts.qty + '">' +
                        '<button type="button" class="qty-btn" data-review-qty-plus data-row-type="' + opts.rowType + '" data-row-id="' + opts.rowId + '">+</button>' +
                    '</div>'
                )
                : "";

            return (
                '<div class="review-row" data-review-row data-row-type="' + opts.rowType + '" data-row-id="' + opts.rowId + '">' +
                    '<div class="review-row-info">' +
                        '<div class="review-row-title">' + $("<div>").text(opts.title).html() + '</div>' +
                        // '<div class="review-row-unit-note">' + unitNote + '</div>' +
                        '<a href="#" class="review-row-remove" data-review-remove data-row-type="' + opts.rowType + '" data-row-id="' + opts.rowId + '">Remove</a>' +
                    '</div>' +
                    '<div class="review-row-side">' +
                        '<div class="review-row-price">' + formatMoney(totalCents) + '</div>' +
                        qtyControls +
                    '</div>' +
                '</div>'
            );
        }

        function renderReview() {
            var $mainInput = getSelectedMainInput();
            $reviewListEl.empty();

            if (!$mainInput.length) {
                $reviewListEl.append('<div class="review-row"><span>No item selected yet</span><span>\u2014</span></div>');
                return;
            }

            var mainPriceCents = Number($mainInput.attr("data-multiple-price")) || 0;
            var mainTitle = $mainInput.attr("data-variant-title");
            var mainQty = getQuantity();

            $reviewListEl.append(reviewRowHtml({
                rowType: "main",
                rowId: $mainInput.val(),
                title: mainTitle,
                unitPriceCents: mainPriceCents,
                qty: mainQty,
                showQtyControls: true
            }));

            var addonTotalCents = 0;
            getSelectedAddonInputs().each(function () {
                var $addon = $(this);
                var addonId = $addon.val();
                var price = Number($addon.attr("data-multiple-price")) || 0;
                var qty = getAddonQty(addonId);
                addonTotalCents += price * qty;

                $reviewListEl.append(reviewRowHtml({
                    rowType: "addon",
                    rowId: addonId,
                    title: $addon.attr("data-variant-title"),
                    unitPriceCents: price,
                    qty: qty,
                    showQtyControls: true
                }));
            });

            var totalCents = (mainPriceCents * mainQty) + addonTotalCents;

            // $reviewListEl.append(
            //     '<div class="review-row review-row-total">' +
            //         "<span>Total</span>" +
            //         "<span>" + formatMoney(totalCents) + "</span>" +
            //     "</div>"
            // );

            var available = $mainInput.attr("data-unavailable") !== "true";
            $wizardAddToCartBtn.prop("disabled", !available);
            $wizardAddToCartBtn.find("[data-wizard-add-to-cart-label]").text(
                available ? ("Add to cart \u2014 " + formatMoney(totalCents)) : "Sold out"
            );
        }

        // Delegated handlers for the review-step controls (rows are rebuilt
        // on every renderReview(), so these must live on a static ancestor).
        $reviewListEl.on("click", "[data-review-qty-minus], [data-review-qty-plus]", function (event) {
            event.preventDefault();
            var $btn = $(this);
            var rowType = $btn.attr("data-row-type");
            var rowId = $btn.attr("data-row-id");
            var delta = $btn.is("[data-review-qty-minus]") ? -1 : 1;

            if (rowType === "main") {
                setQuantity(getQuantity() + delta);
            } else {
                var $addon = $form.find('input[data-psm-signing-addon="1"][value="' + rowId + '"]');
                setAddonQty(rowId, getAddonQty(rowId) + delta, $addon);
            }

            refreshPricing();
            renderReview();
        });

        $reviewListEl.on("click", "[data-review-remove]", function (event) {
            event.preventDefault();
            var $link = $(this);
            var rowType = $link.attr("data-row-type");
            var rowId = $link.attr("data-row-id");

            if (rowType === "main") {
                resetMainSelection();
            } else {
                var $addon = $form.find('input[data-psm-signing-addon="1"][value="' + rowId + '"]');
                $addon.prop("checked", false);
                delete addonQuantities[rowId];
            }

            refreshPricing();
            renderReview();
        });

        /* =================================================================
           MAIN ITEM + ADD-ON PRICING
           ================================================================= */
        function getSelectedMainInput() {
            return $form.find('input[name="signing_item_variant"]:checked').first();
        }

        function getSelectedAddonInputs() {
            return $form.find('input[data-psm-signing-addon="1"]:checked');
        }

        function refreshPricing() {
            var $mainInput = getSelectedMainInput();

            if (!$mainInput.length) {
                $(".line-item .line-title").text("\u2014");
                $(".line-item .line-price").text("\u2014");
                $(".total-row .total-price").text("\u2014");
                $addonLinesEl.empty();
                $addToCartBtn.prop("disabled", true).removeAttr("data-variant-id").removeAttr("data-addon-ids").removeAttr("data-addon-qtys");
                $addToCartBtn.find("span").first().text("Select options");
                if (isOnReviewStep()) renderReview();
                return;
            }

            var mainPriceCents = Number($mainInput.attr("data-multiple-price")) || 0;
            var mainTitle = $mainInput.attr("data-variant-title");
            var mainAvailable = $mainInput.attr("data-unavailable") !== "true";
            var mainVariantId = $mainInput.val();
            var mainQty = getQuantity();

            $(".line-item .line-title").text(mainTitle);
            $(".line-item .line-price").text(formatMoney(mainPriceCents));

            var $addons = getSelectedAddonInputs();
            var addonIds = [];
            var addonQtys = [];
            var addonTotalCents = 0;

            $addonLinesEl.empty();
            $addons.each(function () {
                var $addon = $(this);
                var addonId = $addon.val();
                var price = Number($addon.attr("data-multiple-price")) || 0;
                var qty = getAddonQty(addonId);
                addonTotalCents += price * qty;
                addonIds.push(addonId);
                addonQtys.push(qty);

                $addonLinesEl.append(
                    '<div class="addon-line">' +
                        "<span class='add-on-variant-title-sm'>" + $("<div>").text($addon.attr("data-variant-title")).html() +
                            (qty > 1 ? " \u00d7 " + qty : "") + "</span>" +
                        "<span class='add-on-variant-price-sm'>+" + formatMoney(price * qty) + "</span>" +
                    "</div>"
                );
            });

            var totalCents = (mainPriceCents * mainQty) + addonTotalCents;
            $(".total-row .total-price").text(formatMoney(totalCents));

            if (!mainAvailable) {
                $addToCartBtn.prop("disabled", true).removeAttr("data-variant-id").removeAttr("data-addon-ids").removeAttr("data-addon-qtys");
                $addToCartBtn.find("span").first().text("Sold out");
            } else {
                $addToCartBtn
                    .prop("disabled", false)
                    .attr("data-variant-id", mainVariantId)
                    .attr("data-addon-ids", addonIds.join(","))
                    .attr("data-addon-qtys", addonQtys.join(","));
                $addToCartBtn.find("span").first().text("Add to cart \u2014 " + formatMoney(totalCents));
            }

            if (isOnReviewStep()) renderReview();
        }

        /* =================================================================
           CATEGORY TOGGLE (Pick one of ours / Send in your own)
           ================================================================= */
        function resetMainSelection() {
            $(".toggle-row .toggle-tile")
                .removeClass("is-selected")
                .find(".psm-signing-source-pill input")
                .prop("checked", false);

            $(".option-list.product-variant-option-list").removeClass("selected-variant");
        }

        function selectTile($tile) {
            $tile.addClass("is-selected").find(".psm-signing-source-pill input").prop("checked", true);
        }

        function showMatchingVariant(hasSigning) {
            $(".option-list.product-variant-option-list").each(function () {
                if ($(this).attr("data-has-signing") === hasSigning) {
                    $(this).addClass("selected-variant");
                    $(this).find(".option-row").first().find("input").prop("checked", true);
                }
            });
        }

        $(".toggle-row").on("click", ".toggle-tile", function () {
            var $tile = $(this);
            var hasSigning = $tile.attr("data-has-signing");

            resetMainSelection();
            selectTile($tile);
            showMatchingVariant(hasSigning);
            refreshPricing();
            setStatus("");
            $("#custom-add_toCart").find("span").css("display", "block");
        });

        /* =================================================================
           MAIN ITEM ROW SELECTION
           ================================================================= */
        $form.on("click", ".product-variant-option-list .option-row, .option-list[data-has-signing] .option-row", function () {
            var $row = $(this);
            var $input = $row.find('input[name="signing_item_variant"]');
            if (!$input.length) return;

            if ($input.prop("disabled") || $input.attr("data-unavailable") === "true") return;

            $('input[name="signing_item_variant"]').prop("checked", false);
            $input.prop("checked", true);

            refreshPricing();
            setStatus("");
            $("#custom-add_toCart").find("span").css("display", "block");
        });

        /* =================================================================
           ADD-ON ROW SELECTION (multiple allowed)
           ================================================================= */
        $form.on("click", ".addon-option-list .option-row", function (event) {
            var $row = $(this);
            var $checkbox = $row.find('input[data-psm-signing-addon="1"]');
            if (!$checkbox.length) return;
            if ($checkbox.prop("disabled") || $checkbox.attr("data-unavailable") === "true") return;

            if (!$(event.target).is("input")) {
                var nowChecked = !$checkbox.prop("checked");
                $checkbox.prop("checked", nowChecked);
                if (nowChecked) {
                    setAddonQty($checkbox.val(), 1, $checkbox);
                } else {
                    delete addonQuantities[$checkbox.val()];
                }
            }

            refreshPricing();
        });

        $form.on("change", '.addon-option-list input[data-psm-signing-addon="1"]', function () {
            var $checkbox = $(this);
            if ($checkbox.prop("checked")) {
                setAddonQty($checkbox.val(), getAddonQty($checkbox.val()), $checkbox);
            } else {
                delete addonQuantities[$checkbox.val()];
            }
            refreshPricing();
        });

        /* =================================================================
           ADD TO CART — promise based, supports main item + N add-ons,
           each with its own quantity
           ================================================================= */
        function addItemsToCart(items) {
            return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items })
            }).then(function (response) {
                if (!response.ok) {
                    return response.json().then(function (err) {
                        throw new Error(err.description || "Could not add item(s) to cart.");
                    });
                }
                return response.json();
            });
        }

        function getCartState() {
            return fetch("/cart.js").then(function (response) {
                return response.json();
            });
        }

        function getOpenDrawer() {
            console.log("drawer open");
            $("#CartDrawer").addClass("active");
            $(".cart_drawer_overlay").addClass("active");
            $("#custom_cart").trigger("click");
        }

        function performAddToCart() {
            var variantId = $addToCartBtn.attr("data-variant-id");
            if (!variantId) {
                setStatus("Please select an option first.", true);
                return;
            }

            var addonIdsAttr = $addToCartBtn.attr("data-addon-ids") || "";
            var addonQtysAttr = $addToCartBtn.attr("data-addon-qtys") || "";
            var addonIds = addonIdsAttr.split(",").filter(function (id) { return id; });
            var addonQtys = addonQtysAttr.split(",").filter(function (q) { return q; });

            var mainQty = getQuantity();

            var items = [{ id: variantId, quantity: mainQty }];
            addonIds.forEach(function (id, i) {
                var qty = parseInt(addonQtys[i], 10) || 1;
                items.push({ id: id, quantity: qty });
            });

            var idleText = $statusEl.text();
            var idleIsError = $statusEl.hasClass("is-error");

            $addToCartBtn.prop("disabled", true);
            $($addToCartBtn).find("span").css("display", "none");
            $wizardAddToCartBtn.prop("disabled", true);
            setStatus("Adding to cart\u2026");

            addItemsToCart(items)
                .then(async function () {
                    setStatus("Added to cart!", false, 3000, "Add to cart", false);
                    $("#custom_cart .cart_count").text(items.length);

                    getCartState();
                    await getOpenDrawer();
                })
                .then(function (cart) {
                    $(document).trigger("cart:refresh", [cart]);
                })
                .catch(function (err) {
                    setStatus(err.message || "Something went wrong.", true);
                })
                .finally(function () {
                    $addToCartBtn.prop("disabled", false);
                    $wizardAddToCartBtn.prop("disabled", false);
                });
        }

        $addToCartBtn.on("click", function (event) {
            event.preventDefault();
            performAddToCart();
        });

        $wizardAddToCartBtn.on("click", function (event) {
            event.preventDefault();
            performAddToCart();
        });

        // -----------------------------------------------------------------
        // Init
        // -----------------------------------------------------------------
        initWizard();
        refreshPricing();
    });

})(jQuery);






// (function ($) {

//     $(document).ready(function () {

//         var $form = $("#add-multiple-variant-form");
//         if (!$form.length) return;

//         var moneyFormat = $form.attr("data-money-format") || "${{amount}}";
//         var $addToCartBtn = $("#custom-add_toCart");
//         var $wizardAddToCartBtn = $form.find("[data-wizard-add-to-cart]");
//         var $statusEl = $(".status");
//         var $addonLinesEl = $(".addon-lines");
//         var $reviewListEl = $form.find("[data-review-list]");

//         // Set by initWizard(); used by refreshPricing() to keep the review
//         // step in sync if the shopper edits a choice and returns to it.
//         var wizardGoToStep = null;
//         var isOnReviewStep = function () { return false; };

//         // -----------------------------------------------------------------
//         // Money formatting — data-multiple-price is in cents.
//         // -----------------------------------------------------------------
//         function formatMoney(cents) {
//             if (cents === undefined || cents === null || cents === "" || isNaN(cents)) {
//                 return "";
//             }
//             var value = (Number(cents) / 100).toFixed(2);
//             var parts = value.split(".");
//             parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//             value = parts.join(".");

//             if (moneyFormat.indexOf("{{amount}}") > -1) {
//                 return moneyFormat.replace("{{amount}}", value);
//             }
//             if (moneyFormat.indexOf("{{amount_no_decimals}}") > -1) {
//                 return moneyFormat.replace("{{amount_no_decimals}}", parts[0]);
//             }
//             return "$" + value;
//         }

//         function setStatus(message, isError) {
//             $statusEl.text(message || "").toggleClass("is-error", !!isError);
//         }

//         /* =================================================================
//            WIZARD STEP CONTROLLER
//            Only activates if there is more than one .steps block in the
//            form. Works identically on first paint and on a hard reload,
//            since it re-derives everything from the current DOM state
//            (whichever .steps already has class="step-active" from Liquid).
//            ================================================================= */
//         function initWizard() {
//             var $steps = $form.find(".steps");
//             var $progress = $form.find("[data-progress]");
//             var $stepCountEl = $form.find("[data-step-count]");
//             var $stepTitleEl = $form.find("[data-step-title]").first();
//             var $backBtn = $form.find("[data-back-btn]");
//             var $startHereNew = $form.find("[data-start-here-btn]");
//             var $continueBtn = $form.find("[data-continue-btn]");
//             var $wizardActions = $form.find("[data-wizard-actions]");

//             if ($steps.length <= 1) {
//                 // Nothing to page through — hide the wizard chrome entirely.
//                 $progress.hide();
//                 $wizardActions.hide();
//                 $form.find("[data-step-count]").hide();
//                 if ($steps.length === 1) $steps.eq(0).addClass("step-active");
//                 return;
//             }

//             // Build progress segments to match the actual number of steps.
//             $progress.empty();
//             $steps.each(function () {
//                 $progress.append('<div class="progress-seg"><div class="progress-seg-fill"></div></div>');
//             });

//             var currentIndex = $steps.index($steps.filter(".step-active"));
//             if (currentIndex < 0) currentIndex = 0;
//             function renderStep(index) {
//                 $steps.removeClass("step-active");
//                 var $active = $steps.eq(index).addClass("step-active");

//                 $stepCountEl.text("STEP " + (index + 1) + " OF " + $steps.length);

//                 var title = $active.attr("data-step-title");
//                 if (title) $stepTitleEl.text(title);

//                 $progress.find(".progress-seg").each(function (i) {
//                     var pct = i <= index ? "100%" : "0%";
//                     $(this).find(".progress-seg-fill").css("width", pct);
//                 });

//                 var isLastStep = index === $steps.length - 1;
//                 var isFirstStep = index === 0;

//                 // Back button hidden on the very first step, shown after Continue.
//                 $backBtn.toggle(!isFirstStep);

//                 // "Start here" only shows on step 1, hidden everywhere else.
//                 $startHereNew.toggle(isFirstStep);

//                 // Continue shows on every step except the last (review) step,
//                 // where the final Add to Cart button takes its place.
//                 $continueBtn.toggle(!isLastStep);
//                 $wizardAddToCartBtn.toggle(isLastStep);

//                 if (isLastStep) {
//                     renderReview();
//                 }
//             }

//             $backBtn.on("click", function () {
//                 if (currentIndex > 0) {
//                     currentIndex -= 1;
//                     renderStep(currentIndex);
//                 }
//             });

//             $continueBtn.on("click", function () {
//                 if (currentIndex < $steps.length - 1) {
//                     currentIndex += 1;
//                     renderStep(currentIndex);
//                 }
//             });

//             $form.on("click", "[data-edit-choices]", function (event) {
//                 event.preventDefault();
//                 currentIndex = 0;
//                 renderStep(currentIndex);
//             });

//             renderStep(currentIndex);

//             // Exposed so refreshPricing() can re-render the review list
//             // live if the shopper goes back and changes a selection, then
//             // returns to the review step again.
//             wizardGoToStep = function (index) {
//                 currentIndex = index;
//                 renderStep(currentIndex);
//             };
//             isOnReviewStep = function () {
//                 return currentIndex === $steps.length - 1;
//             };
//         }

//         function renderReview() {
//             var $mainInput = getSelectedMainInput();
//             $reviewListEl.empty();

//             if (!$mainInput.length) {
//                 $reviewListEl.append('<div class="review-row"><span>No item selected yet</span><span>\u2014</span></div>');
//                 return;
//             }

//             var mainPriceCents = Number($mainInput.attr("data-multiple-price")) || 0;
//             var mainTitle = $mainInput.attr("data-variant-title");

//             $reviewListEl.append(
//                 '<div class="review-row">' +
//                     "<span>" + $("<div>").text(mainTitle).html() + "</span>" +
//                     "<span>" + formatMoney(mainPriceCents) + "</span>" +
//                 "</div>"
//             );

//             var addonTotalCents = 0;
//             getSelectedAddonInputs().each(function () {
//                 var $addon = $(this);
//                 var price = Number($addon.attr("data-multiple-price")) || 0;
//                 addonTotalCents += price;

//                 $reviewListEl.append(
//                     '<div class="review-row">' +
//                         "<span>" + $("<div>").text($addon.attr("data-variant-title")).html() + "</span>" +
//                         "<span>+" + formatMoney(price) + "</span>" +
//                     "</div>"
//                 );
//             });

//             var totalCents = mainPriceCents + addonTotalCents;
//             $reviewListEl.append(
//                 '<div class="review-row review-row-total">' +
//                     "<span>Total</span>" +
//                     "<span>" + formatMoney(totalCents) + "</span>" +
//                 "</div>"
//             );

//             var available = $mainInput.attr("data-unavailable") !== "true";
//             $wizardAddToCartBtn.prop("disabled", !available);
//             $wizardAddToCartBtn.find("[data-wizard-add-to-cart-label]").text(
//                 available ? ("Add to cart \u2014 " + formatMoney(totalCents)) : "Sold out"
//             );
//         }

//         /* =================================================================
//            MAIN ITEM + ADD-ON PRICING
//            ================================================================= */
//         function getSelectedMainInput() {
//             return $form.find('input[name="signing_item_variant"]:checked').first();
//         }

//         function getSelectedAddonInputs() {
//             return $form.find('input[data-psm-signing-addon="1"]:checked');
//         }

//         function refreshPricing() {
//             var $mainInput = getSelectedMainInput();

//             if (!$mainInput.length) {
//                 $(".line-item .line-title").text("\u2014");
//                 $(".line-item .line-price").text("\u2014");
//                 $(".total-row .total-price").text("\u2014");
//                 $addonLinesEl.empty();
//                 $addToCartBtn.prop("disabled", true).removeAttr("data-variant-id").removeAttr("data-addon-ids");
//                 $addToCartBtn.find("span").first().text("Select options");
//                 if (isOnReviewStep()) renderReview();
//                 return;
//             }

//             var mainPriceCents = Number($mainInput.attr("data-multiple-price")) || 0;
//             var mainTitle = $mainInput.attr("data-variant-title");
//             var mainAvailable = $mainInput.attr("data-unavailable") !== "true";
//             var mainVariantId = $mainInput.val();

//             $(".line-item .line-title").text(mainTitle);
//             $(".line-item .line-price").text(formatMoney(mainPriceCents));

//             // Add-ons: build summary lines + running total.
//             var $addons = getSelectedAddonInputs();
//             var addonIds = [];
//             var addonTotalCents = 0;

//             $addonLinesEl.empty();
//             $addons.each(function () {
//                 var $addon = $(this);
//                 var price = Number($addon.attr("data-multiple-price")) || 0;
//                 addonTotalCents += price;
//                 addonIds.push($addon.val());

//                 $addonLinesEl.append(
//                     '<div class="addon-line">' +
//                         "<span class='add-on-variant-title-sm'>" + $("<div>").text($addon.attr("data-variant-title")).html() + "</span>" +
//                         "<span class='add-on-variant-price-sm'>+" + formatMoney(price) + "</span>" +
//                     "</div>"
//                 );
//             });

//             var totalCents = mainPriceCents + addonTotalCents;
//             $(".total-row .total-price").text(formatMoney(totalCents));

//             if (!mainAvailable) {
//                 $addToCartBtn.prop("disabled", true).removeAttr("data-variant-id").removeAttr("data-addon-ids");
//                 $addToCartBtn.find("span").first().text("Sold out");
//             } else {
//                 $addToCartBtn
//                     .prop("disabled", false)
//                     .attr("data-variant-id", mainVariantId)
//                     .attr("data-addon-ids", addonIds.join(","));
//                 $addToCartBtn.find("span").first().text("Add to cart \u2014 " + formatMoney(totalCents));
//             }

//             if (isOnReviewStep()) renderReview();
//         }

//         /* =================================================================
//            CATEGORY TOGGLE (Pick one of ours / Send in your own)
//            ================================================================= */
//         function resetMainSelection() {
//             $(".toggle-row .toggle-tile")
//                 .removeClass("is-selected")
//                 .find(".psm-signing-source-pill input")
//                 .prop("checked", false);

//             $(".option-list.product-variant-option-list").removeClass("selected-variant");
//             //$('input[name="signing_item_variant"]').prop("checked", false);
//         }

//         function selectTile($tile) {
//             $tile.addClass("is-selected").find(".psm-signing-source-pill input").prop("checked", true);
//         }

//         function showMatchingVariant(hasSigning) {
//             $(".option-list.product-variant-option-list").each(function () {
//                 if ($(this).attr("data-has-signing") === hasSigning) {
//                     $(this).addClass("selected-variant");
//                     $(this).find(".option-row").first().find("input").prop("checked", true);
//                 }
//             });
//         }

//         $(".toggle-row").on("click", ".toggle-tile", function () {
//             var $tile = $(this);
//             var hasSigning = $tile.attr("data-has-signing");

//             resetMainSelection();
//             selectTile($tile);
//             showMatchingVariant(hasSigning);
//             refreshPricing();
//             setStatus("");
//             $("#custom-add_toCart").find("span").css("display", "block");
//         });

//         /* =================================================================
//            MAIN ITEM ROW SELECTION
//            ================================================================= */
//         $form.on("click", ".product-variant-option-list .option-row, .option-list[data-has-signing] .option-row", function () {
//             var $row = $(this);
//             var $input = $row.find('input[name="signing_item_variant"]');
//             if (!$input.length) return;

//             if ($input.prop("disabled") || $input.attr("data-unavailable") === "true") return;

//             $('input[name="signing_item_variant"]').prop("checked", false);
//             $input.prop("checked", true);

//             refreshPricing();
//             setStatus("");
//             $("#custom-add_toCart").find("span").css("display", "block");
//         });

//         /* =================================================================
//            ADD-ON ROW SELECTION (multiple allowed)
//            ================================================================= */
//         $form.on("click", ".addon-option-list .option-row", function (event) {
//             var $row = $(this);
//             var $checkbox = $row.find('input[data-psm-signing-addon="1"]');
//             if (!$checkbox.length) return;
//             if ($checkbox.prop("disabled") || $checkbox.attr("data-unavailable") === "true") return;

//             // Avoid double-toggling when the click originated on the checkbox itself.
//             if (!$(event.target).is("input")) {
//                 $checkbox.prop("checked", !$checkbox.prop("checked"));
//             }

//             refreshPricing();
//         });

//         $form.on("change", '.addon-option-list input[data-psm-signing-addon="1"]', function () {
//             refreshPricing();
//         });

//         /* =================================================================
//            ADD TO CART — promise based, supports main item + N add-ons
//            ================================================================= */
//         function addItemsToCart(items) {
//             return fetch("/cart/add.js", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ items: items })
//             }).then(function (response) {
//                 if (!response.ok) {
//                     return response.json().then(function (err) {
//                         throw new Error(err.description || "Could not add item(s) to cart.");
//                     });
//                 }
//                 return response.json();
//             });
//         }
        
//         function getCartState() {
//             return fetch("/cart.js").then(function (response) {
//                     return response.json();
//             });
//         }

//          function getOpenDrawer() {
//             console.log("drawer open");
//             $("#CartDrawer").addClass("active");
//             $(".cart_drawer_overlay").addClass("active");
//             $("#custom_cart").trigger("click");
//         }

//          function performAddToCart() {
//             var variantId = $addToCartBtn.attr("data-variant-id");
//             if (!variantId) {
//                 setStatus("Please select an option first.", true);
//                 return;
//             }

//             var addonIdsAttr = $addToCartBtn.attr("data-addon-ids") || "";
//             var addonIds = addonIdsAttr.split(",").filter(function (id) { return id; });

//             var items = [{ id: variantId, quantity: 1 }];
//             addonIds.forEach(function (id) {
//                 items.push({ id: id, quantity: 1 });
//             });

//             $addToCartBtn.prop("disabled", true);
//             $($addToCartBtn).find("span").css("display", "none");
//             $wizardAddToCartBtn.prop("disabled", true);
//             setStatus("Adding to cart\u2026");

//             addItemsToCart(items)
//                     .then(async function () {
//                     setStatus("Added to cart!");
//                     $("#custom_cart .cart_count").text(items.length);
//                     console.log("cart added", items);

//                     getCartState();
//                     await getOpenDrawer();
//                 })
//                 .then(function (cart) {
//                     $(document).trigger("cart:refresh", [cart]);
//                 })
//                 .catch(function (err) {
//                     setStatus(err.message || "Something went wrong.", true);
//                 })
//                 .finally(function () {
//                     $addToCartBtn.prop("disabled", false);
//                     $wizardAddToCartBtn.prop("disabled", false);

//                 });
//         }

//         $addToCartBtn.on("click", function (event) {
//             event.preventDefault();
//             performAddToCart();
//         });

//         $wizardAddToCartBtn.on("click", function (event) {
//             event.preventDefault();
//             performAddToCart();
//         });

//         // -----------------------------------------------------------------
//         // Init
//         // -----------------------------------------------------------------
//         initWizard();
//         refreshPricing();
//     });

// })(jQuery);
